import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GridDataResult, KENDO_GRID, PageChangeEvent, PagerSettings } from '@progress/kendo-angular-grid';
import { ForcePublishReceiversService } from './force-publish-receivers.service';
import { Observable } from 'rxjs';
import { CompositeFilterDescriptor, State } from '@progress/kendo-data-query';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EditForcePublishReceiverComponent } from './child-components/edit-force-publish-receiver.component';
import { ConfirmDeleteComponent } from '../items/child-components/confirm-delete.component';
import { ForcePublishReceiverResponseModel } from './models/force-publish-receiver-response-model';

@Component({
  selector: 'app-force-publish-receivers',
  standalone: true,
  imports: [CommonModule, FormsModule, KENDO_GRID, NgbModule],
  providers: [ForcePublishReceiversService],
  templateUrl: './force-publish-receivers.component.html'
})
export class ForcePublishReceiversComponent implements OnInit {
  public view: Observable<GridDataResult>;
  public error: boolean = false;
  public errorMessage: string = '';
  public validationMessage: string = '';

  public state: State = {
    skip: 0,
    take: 20,
  };

  public pageableSettings: PagerSettings = {
    pageSizes: [10, 20, 50, 100]
  };

  public filter: CompositeFilterDescriptor = {
    logic: 'and',
    filters: [],
  };

  constructor(public receiversService: ForcePublishReceiversService, private modalService: NgbModal) {
    this.view = receiversService;
    this.receiversService.query(this.state, this.filter);
  }

  ngOnInit(): void {}

  public pageChange(state: PageChangeEvent): void {
    this.state.skip = state.skip;
    this.state.take = state.take;
    this.receiversService.query(this.state, this.filter);
  }

  public filterChange(filter: CompositeFilterDescriptor): void {
    this.filter = filter;
    this.state.skip = 0;
    this.receiversService.query(this.state, this.filter);
  }

  public addReceiver() {
    const modalRef = this.modalService.open(EditForcePublishReceiverComponent, { size: 'lg' });
    modalRef.componentInstance.isNew = true;

    modalRef.result.then((result) => {
      if (result?.action === 'save') {
        this.receiversService.query(this.state, this.filter);
      }
    }, () => {});
  }

  public editReceiver(row: ForcePublishReceiverResponseModel) {
    const modalRef = this.modalService.open(EditForcePublishReceiverComponent, { size: 'lg' });
    modalRef.componentInstance.isNew = false;
    modalRef.componentInstance.receiver = row;

    modalRef.result.then((result) => {
      if (result?.action === 'save') {
        this.receiversService.query(this.state, this.filter);
      }
    }, () => {});
  }

  public deleteReceiver(row: ForcePublishReceiverResponseModel) {
    const modalRef = this.modalService.open(ConfirmDeleteComponent);
    modalRef.componentInstance.title = 'Confirm Delete';
    modalRef.componentInstance.message = `Are you sure you want to delete receiver "${row.receiver}"?`;

    modalRef.result.then((result) => {
      if (result === 'confirmed') {
        this.receiversService.delete(row.id).subscribe({
          next: () => {
            this.receiversService.query(this.state, this.filter);
          },
          error: (error) => {
            console.error('Error deleting receiver:', error);
            this.error = true;
            this.errorMessage = error?.error?.message || error?.message || 'Failed to delete the receiver. Please try again.';
          }
        });
      }
    }, () => {});
  }
}
